export { default } from '@shikijs/langs/json'
